import { appendReduxParts } from "infrastructure/store";

import ReleaseDetails from "./ReleaseDetails";
import { releaseDetailsSaga } from "./ReleaseDetails.saga";
import { releaseDetailsManager } from "./ReleaseDetails.slice";

export * from "./ReleaseDetails.slice";
export { ReleaseDetails };

appendReduxParts(
  [
    {
      reducerName: releaseDetailsManager.name,
      reducer: releaseDetailsManager.reducer
    }
  ],
  [releaseDetailsSaga()]
);
